// extracted by mini-css-extract-plugin
module.exports = {"ArrowDown":"Icons_ArrowDown__2AwKT","ArrowUp":"Icons_ArrowUp__1jc18"};